<template>
  <tr v-link="{ path: `/item-groups/${product.id}` }">
    <td>
      <span class="brand">{{ product.brand }}</span>
      <h4>{{ product.name }}</h4>
      <code>{{ product.upc_13 }}</code>
    </td>
    <td>
      {{ item.next_pickup_at | date-format 'time' }}<br />
      <small
        class="text-nowrap"
        >{{ item.next_pickup_at | date-format 'date' }}</small
      >
    </td>
    <td>{{ item.order_count }}</td>
    <td>
      {{ item.weight | fractional }}
      {{ product.unit_of_measure | unit-of-measure item.weight true }}
    </td>
  </tr>
</template>

<script>
import Item from './Item';

export default { ...Item };
</script>



// WEBPACK FOOTER //
// ItemGroup.vue?0ff89909